export const linguisticJoin = (array: string[], joiner = 'and') => {
  if (array.length === 0) {
    return '';
  }
  if (array.length === 1) {
    return array[0];
  }
  if (array.length === 2) {
    return `${array[0]} ${joiner} ${array[1]}`;
  }
  return `${array.slice(0, -1).join(', ')}, ${joiner} ${array[array.length - 1]}`;
};
